import { render, staticRenderFns } from "./QuoteProgramDetachedPageDialog.vue?vue&type=template&id=0a1686e2"
import script from "./QuoteProgramDetachedPageDialog.vue?vue&type=script&lang=js"
export * from "./QuoteProgramDetachedPageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports